import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    ProductType,
} from 'app/enums/label.enums'

import {
    ContainerStatusBreakdownType,
} from '../ScenarioEditor.types'

const getColumns = (
    l: (l: string) => string,
): RichTableColumns<keyof ContainerStatusBreakdownType>[] => {
    return [
        {
            id: 'productType',
            headerProps: {
                children: l('PRODUCT_TYPE'),
            },
            mapCellProps: 'productType',
            componentName: 'EnumValue',
            allowedValuesEnum: ProductType,
        },
        {
            id: 'preconditioning',
            headerProps: {
                children: l('PRE-CONDITIONING'),
            },
            mapCellProps: 'preconditioning',
        },
        {
            id: 'checkPreconditioning',
            headerProps: {
                children: l('CHECK_PRE-CONDITIONING'),
            },
            mapCellProps: 'checkPreconditioning',
        },
        {
            id: 'preconditioned',
            headerProps: {
                children: l('PRE-CONDITIONED'),
            },
            mapCellProps: 'preconditioned',
        },
        {
            id: 'qcPassed',
            headerProps: {
                children: l('QC_PASSED'),
            },
            mapCellProps: 'qcPassed',
        },
        {
            id: 'qcPassedAutomated',
            headerProps: {
                children: l('QC_PASSED_AUTOMATED'),
            },
            mapCellProps: 'qcPassedAutomated',
        },
        {
            id: 'toBeMaintained',
            headerProps: {
                children: l('TO_BE_MAINTAINED'),
            },
            mapCellProps: 'toBeMaintained',
        },
    ]
}

export default getColumns
